import React, { useMemo } from 'react';
import { fetcher } from 'api/client';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { fetchProcesses } from 'api/actions/users';
import ReactTable from 'components/Shared/ReactTable';
import { noop, parseDate } from 'utils';

function Processes() {
    const { t } = useTranslation();

    const { data, isSuccess } = useQuery('processes', () => fetcher(fetchProcesses()));
    const columns = useMemo(() => [
        {
            Header: t('processes.subtitle'),
            columns: [
                {
                    Header: t('processes.createdAt'),
                    accessor: row => parseDate(row.createdAt, 'Pp'),
                    type: 'input',
                },
                {
                    Header: t('processes.status'),
                    accessor: row => row.active ? t('process.active') : t('process.inactive'),
                    type: 'input',
                },
                {
                    Header: t('processes.contracts'),
                    accessor: 'contracts.length',
                    type: 'input',
                },
                {
                    Header: t('processes.processed'),
                    accessor: 'processed.length',
                    type: 'input',
                },
                {
                    Header: t('processes.progress'),
                    accessor: 'progress',
                    type: 'input',
                },
            ],
        }
    ], [t]);
    return (
        <div className="profile-users">
            <h5>
                <i className="fas fa-file"></i>  {t('processes.title')}
            </h5>
            {isSuccess &&
                <ReactTable
                    readOnly="true"
                    className="reportTable"
                    columns={columns}
                    data={data}
                    setnewData={noop}
                    newData={{}}
                    showCreate={false}
                    setshowCreate={noop}
                    key="processTable"
                />
            }
        </div>
    )
}

export default Processes;